export default "__VITE_ASSET__e5dd77b0__"